import BaseReportController from '../../baseReportController';
import { map as _map } from 'lodash';
import { sumBy as _sumBy } from 'lodash';

class LastLoginController extends BaseReportController {
  constructor(authService, reportingService, userService, enums, loadingService, lookupService, $q, $scope, printService, exportService, utilsService) {
    "ngInject";

    super(reportingService, loadingService, utilsService);

    if(!authService.validateUser(true, 'Reports', enums.PERMISSION_TYPE.View, true)) { return; }

    this.authService = authService;
    this.reportingService = reportingService;
    this.userService = userService;
    this.enums = enums;
    this.loadingService = loadingService;
    this.lookupService = lookupService;
    this.$q = $q;
    this.$scope = $scope;
    this.printService = printService;
    this.exportService = exportService;
    this.utilsService = utilsService;

    this.reportCriteria = {};
    this.dtPopups = {};
    this.errMsgs = [];

    this.panels = {
      reportCriteria: true,
      reportSummary: false,
      reportData: false
    };

    this.summary = [];
    this.locationDetailsHidden = [];

    this.reset();
  }

  convertEnumToKeyValueList(enumObj, defaultOption) {
    let objList = [];

    if (defaultOption) {
      objList.push({
        id: null,
        name: 'Please Select'
      })
    }

    for(let prop in enumObj){
      objList.push({
        id: enumObj[prop],
        name: prop
      });
    }

    return objList;
  }

  reset() {
    this.$scope.$broadcast('reports:reset');
    
    this.summary = [];

    this.errMsgs = [];

    this.reportCriteria.additionalParameter1 = "0";
  }

  runReport() {
    this.panels.reportData = true;

    this.$scope.$broadcast('reports:runReport', {
      action: 'lastLogin',
      criteriaValidator: this.validateCriteria.bind(this), 
      criteriaParser: this.parseCriteria.bind(this)
    });
  }  

  validateCriteria() {
    this.errMsgs = [];

    return this.errMsgs.length === 0;
  }

  parseCriteria() {
    let parsedCriteria = {};

    this.parseStartAndEndDate(parsedCriteria);    
    parsedCriteria.additionalParameter1 = this.reportCriteria.additionalParameter1;

    return parsedCriteria;
  }

  printReport(){
    if (!this.validateCriteria()) {
      return;
    }

    this.printService.printReport('Last Login', this.parseCriteria());
  }    
  
  exportReport(){
    if (!this.validateCriteria()) {
      return;
    }

    this.exportService.exportReport('Last Login', this.parseCriteria());
  }    
}

export default LastLoginController;



// WEBPACK FOOTER //
// ./client/app/components/reports/adminReports/lastLogin/lastLogin.controller.js